import React from "react";

export default function EmptyState({ icon, msg }) {
  return (
    <div className="adm-style-117">
      <div className="adm-style-118">{icon}</div>
      <div className="adm-style-119">{msg}</div>
    </div>
  );
}
